import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Popover from "@mui/material/Popover";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
// import SearchIcon from "@mui/icons-material/Search";
import { setAuthUser, setAuthToken } from "app/redux/authReducer";
import GA, { EVENT_NAMES } from "../../../services/googleAnalytics";
import defaultAvatar from "app/assets/svg/default_avatar.svg";
import logoImg from "app/assets/svg/logo.svg";
// import logo from "app/assets/images/logo.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell } from "@fortawesome/free-solid-svg-icons";

function Header({
  headerClassName,
  navItems,
  activeNavItem,
  // setShowMobileNoti
}) {
  const [loggedInMenuAnchorEl, setLoggedInMenuAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);
  const openLoggedInMenu = (e) => {
    setLoggedInMenuAnchorEl(e.currentTarget);
  };

  const closeLoggedInMenu = () => {
    setLoggedInMenuAnchorEl(null);
  };

  const handleLogout = () => {
    closeLoggedInMenu();
    const token = {
      accessToken: null,
      refreshToken: null,
    };
    GA.logout();
    GA.tracking(EVENT_NAMES.HEADER.CLICK_LOGOUT);
    dispatch(setAuthUser(null));
    dispatch(setAuthToken(token));
  };

  return (
    <>
      <header
        className={`sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200 shadow-sm ${
          headerClassName || ""
        }`}
      >
        <div className="w-full h-full py-0 px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Link
              onClick={() => GA.tracking(EVENT_NAMES.HEADER.NAV_HOME)}
              to="/"
              className="flex items-center gap-2"
            >
              {/* <img className="h-[32px]" src={logoImg} alt="Logo" /> */}
              <span className="material-symbols-outlined text-sky-500 text-3xl">bubble_chart</span>
              <h1 className="text-lg font-bold text-slate-800 tracking-tight">
                頭皮labo{" "}
                <span className="text-xs font-normal text-slate-400 ml-1">
                  Professional
                </span>
              </h1>
              {/* <h2 className="text-base sm:text-lg md:text-xl font-semibold">
                <span className="text-white font-sans">TOUHI</span>
                <span>LABO</span>
              </h2> */}
            </Link>
          </div>
          {/* <div className="w-1/3 h-12 border border-[#dddddd] rounded-full shadow-[0_4px_12px_4px_rgba(0,0,0,0.088)] relative py-1 pl-12 pr-3 hidden md:block">
            <div className="absolute top-1/2 left-1 -translate-y-1/2 w-10 h-10 p-1 rounded-full bg-gray-200">
              <SearchIcon classes={{ root: "!text-[32px]" }} />
            </div>
            <input
              className="w-full h-full !outline-none text px-1"
              placeholder="検索窓..."
            />
          </div> */}
          <button
            // type="button"
            className="text-slate-400 hover:text-primary transition p-1"
            // style={{ "-webkit-appearance": "none" }}
            onClick={openLoggedInMenu}
          >
            <span className="material-symbols-outlined">account_circle</span>
          </button>

          {/* <button
            type="button"
            className="ml-4 flex items-center border rounded-full p-1 hover:shadow-md"
            onClick={() => setShowMobileNoti(true)}
          >
            <div className="relative w-[30px] h-[30px] rounded-full bg-[#F0F1EF] bg-opacity-50 flex items-center justify-center col">
              <FontAwesomeIcon icon={faBell} size="xl" color="#717171" />
            </div>
          </button> */}
        </div>

        {/* Navigation Tabs */}
        {navItems && navItems.length > 0 && (
          <div className="max-w-md mx-auto px-4 pb-3 overflow-x-auto no-scrollbar flex gap-2 border-b border-slate-100 bg-white">
            {navItems.map((item, index) => {
              const isActive = activeNavItem === item.href;
              return (
                <a
                  key={index}
                  className={`flex-shrink-0 px-3 py-1 rounded-full border text-xs font-medium transition ${
                    isActive
                      ? "bg-sky-50 border-sky-200 text-primary"
                      : "bg-slate-50 border-slate-200 text-slate-600 hover:bg-sky-50 hover:border-sky-200 hover:text-primary"
                  }`}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(item.href);
                    if (el) el.scrollIntoView({ behavior: 'instant' });
                  }}
                >
                  <span className="mr-1">●</span>{item.label}
                </a>
              );
            })}
          </div>
        )}
      </header>

      <Popover
        open={Boolean(loggedInMenuAnchorEl)}
        anchorEl={loggedInMenuAnchorEl}
        onClose={closeLoggedInMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          classes: {
            root: "w-[210px] md:w-[220px] !rounded-xl !translate-y-2",
          },
        }}
      >
        <MenuList>
          <MenuItem classes={{ root: "!py-1" }}>
            <p className="">{user?.loginName}</p>
          </MenuItem>
          <MenuItem classes={{ root: "!py-1" }} onClick={() => handleLogout()}>
            <p className="">ログアウト</p>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
}

export default Header;
